import { Redirect, Route, Switch } from 'react-router';

import { ROUTES } from '../../constants';
import {
  AdminPanel,
  CreateAccount,
  CreateClinic,
  DynamicLinkSent,
  Login,
  RequestDynamicLink,
} from '../../pages';
import { ProtectedRoute } from '../navigation';

export const RenderRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTES.LOGIN} component={Login} />
      <Route path={ROUTES.CREATE_ACCOUNT} component={CreateAccount} />
      <Route path={ROUTES.CREATE_CLINIC} component={CreateClinic} />
      <Route
        path={ROUTES.REQUEST_DYNAMIC_LINK}
        component={RequestDynamicLink}
      />
      <Route path={ROUTES.DYNAMIC_LINK_SENT} component={DynamicLinkSent} />
      <ProtectedRoute
        path={`${ROUTES.ADMIN_PANEL}/:usersType`}
        component={AdminPanel}
      />
      <Redirect to={ROUTES.LOGIN} />
    </Switch>
  );
};
